import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.9998 21.9L7.0548 16.944L8.4628 15.535L11.9998 19.07L15.5348 15.535L16.9498 16.949L11.9998 21.9ZM8.4628 8.46501L7.0498 7.05001L11.9998 2.10001L16.9438 7.05501L15.5358 8.46301L11.9998 4.92901L8.4638 8.46401L8.4628 8.46501Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "UnfoldMore"
);
